import { Injectable } from '@angular/core';
import * as localForage from 'localforage';

@Injectable()
export class LocalStorageService {

    constructor() {
        localForage.config({
            name: 'prism-admin',
            version: 1
        });
    }

    public async set<T>(key: string, data: T) {
        return localForage.setItem<T>(key, data);
    }

    public async get<T>(key: string) {
        return localForage.getItem<T>(key);
    }

    public async getKeys() {
        return await localForage.keys();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/local-storage.service.ts